import Button from '@/components/base/Button';
import Reveal from '@/components/base/Reveal';
import PageHero from '@/components/feature/PageHero';
import { HOW_IT_WORKS_DETAILED, SERVICES } from '@/data/site';

export default function HowItWorks() {
  return (
    <>
      <PageHero
        eyebrow="How It Works"
        title="A simpler way to find the right people."
        intro="Five clear steps, from sharing your requirements to dealing directly with the supplier you choose."
        imageSrc="https://readdy.ai/api/search-image?query=premium%20corporate%20reception%20and%20networking%20event%20in%20an%20elegant%20London%20venue%2C%20diverse%20guests%20in%20smart%20attire%20conversing%2C%20warm%20ambient%20golden%20lighting%2C%20refined%20professional%20event%20photography%2C%20sophisticated%20welcoming%20atmosphere&width=1600&height=760&seq=kor38-howitworks-hero&orientation=landscape"
        imageAlt="Premium corporate reception and networking event in an elegant venue"
        roomyBottom
      />

      <section className="w-full px-4 md:px-8 lg:px-12 pb-16 md:pb-24 bg-background-50">
        <div className="max-w-content mx-auto">
          <ol className="relative border-l border-background-300 ml-3 md:ml-4 space-y-10 md:space-y-14">
            {HOW_IT_WORKS_DETAILED.map((step, index) => (
              <Reveal key={step.number} as="li" delay={index * 70} className="relative pl-8 md:pl-12">
                <span className="absolute -left-[25px] md:-left-[33px] top-0 w-12 h-12 md:w-16 md:h-16 rounded-full bg-background-50 border border-primary-500/40 flex items-center justify-center">
                  <span className="font-heading text-lg md:text-xl text-primary-300">
                    {step.number}
                  </span>
                </span>
                <h2 className="font-heading text-lg md:text-2xl text-foreground-950">{step.title}</h2>
                <p className="mt-3 text-base leading-relaxed text-foreground-700 max-w-2xl">
                  {step.body}
                </p>
              </Reveal>
            ))}
          </ol>

          <Reveal className="mt-14 rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
            <p className="text-base leading-relaxed text-foreground-700">
              Paid requests are reviewed before payment, and there is no guaranteed supplier
              availability or outcome. KOR38 is an introduction service — not an event planner or
              booking platform.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="w-full px-4 md:px-8 lg:px-12 py-16 md:py-24 bg-background-100 border-t border-background-200">
        <div className="max-w-content mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            Choose the service that fits your request.
          </h2>
          <p className="mt-4 text-base leading-relaxed text-foreground-700 max-w-2xl">
            Each offer has its own dedicated enquiry form so we can capture exactly what we need to
            help you.
          </p>
          <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6">
            {SERVICES.map((service) => (
              <Reveal
                key={service.id}
                className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-6"
              >
                <div className="flex items-center justify-between gap-4">
                  <span className="font-label text-xs uppercase tracking-[0.14em] text-accent-600">
                    {service.subheading}
                  </span>
                  <span className="font-label text-sm font-semibold text-primary-300">
                    {service.price}
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-xl text-foreground-950">{service.name}</h3>
                <div className="mt-auto pt-6 border-t border-background-200">
                  <Button to={service.path} variant="outline" size="md" className="w-full">
                    {service.cta}
                  </Button>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}